// extracted by mini-css-extract-plugin
export default {"field":"search-field_field__bKnin"};